<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 21 21"
  >
    <path
      id="location_on_FILL0_wght300_GRAD0_opsz48"
      d="M12.89,12.434a1.69,1.69,0,0,0,1.2-2.887,1.69,1.69,0,1,0-2.39,2.39A1.629,1.629,0,0,0,12.89,12.434Zm0,9.372a29.574,29.574,0,0,0,5.317-5.975,9.566,9.566,0,0,0,1.8-4.874A7.143,7.143,0,0,0,17.952,5.68,6.879,6.879,0,0,0,12.89,3.625,6.879,6.879,0,0,0,7.828,5.68a7.143,7.143,0,0,0-2.054,5.277A9.477,9.477,0,0,0,7.6,15.831,31.084,31.084,0,0,0,12.89,21.806Zm0,1.611A35.4,35.4,0,0,1,6.633,16.65a10.542,10.542,0,0,1-2.068-5.693A8.061,8.061,0,0,1,7.076,4.74a8.437,8.437,0,0,1,11.628,0,8.061,8.061,0,0,1,2.511,6.217,10.542,10.542,0,0,1-2.068,5.693A35.4,35.4,0,0,1,12.89,23.417ZM12.89,10.957Z"
      transform="translate(-4.565 -2.416)"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
export default {
  props: {
    width: {
      type: Number,
      default: 21,
    },
    height: {
      type: Number,
      default: 21,
    },
  },
};
</script>
<style lang=""></style>
